export enum TicketStatus {
  OPEN = 'open',
  IN_PROGRESS = 'in_progress',
  RESOLVED = 'resolved',
  CLOSED = 'closed',
}

export enum TicketCategory {
  BILLING = 'billing',
  TECHNICAL = 'technical',
  GENERAL = 'general',
  OTHER = 'other',
}

export interface SupportMessage {
  id: string;
  ticket_id: string;
  sender_id: string;
  sender_name: string | null;
  content: string;
  is_admin_reply: boolean;
  created_at: string;
}

export interface SupportTicket {
  id: string;
  user_id: string;
  user_email: string | null;
  user_name: string | null;
  subject: string;
  category: TicketCategory;
  status: TicketStatus;
  created_at: string;
  updated_at: string;
  message_count: number;
  last_message_at: string | null;
}

export interface SupportTicketDetail extends SupportTicket {
  messages: SupportMessage[];
}
